import { airHandlerTypeCodes } from 'data/constants';
import {
  AirHandlerTypeCodeType,
  AirHandlerTypeLabelType,
  CondenserType,
  ConfigurationType
} from 'data/types';

const codeToLabel = (
  Object.entries(airHandlerTypeCodes) as [
    AirHandlerTypeLabelType,
    AirHandlerTypeCodeType
  ][]
).reduce<Record<string, string>>((acc, [label, code]) => {
  acc[code] = label;
  return acc;
}, {});

export type AirHandlerKind = {
  label: string;
  count: number;
};

export function getPlacedCondensers(
  config: ConfigurationType
): CondenserType[] {
  return config.condensers.filter((c) => c.position !== undefined);
}

export function getConfigurationCondenserCount(
  config: ConfigurationType
): number {
  return getPlacedCondensers(config).length;
}

export function getConfigurationAirHandlerKinds(
  config: ConfigurationType
): AirHandlerKind[] {
  const counts = new Map<string, number>();
  config.condensers.forEach((condenser) => {
    condenser.zones.forEach((zone) => {
      const code = zone.airHandler?.airHandlerTypeCode;
      if (!code) return;
      const label = codeToLabel[code] ?? code;
      counts.set(label, (counts.get(label) ?? 0) + 1);
    });
  });
  return Array.from(counts.entries()).map(([label, count]) => ({
    label,
    count
  }));
}
